// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--COf7I","dark":"dark--a3iZP","container":"container--ZXIH2","heading":"heading--rUhDm","fadeSlideUp":"fadeSlideUp--NeJlu"};